<script>
export default {
  props: {
    message: { type: String, default: '' },
    // O mesmo aviso, do tamanho de uma secao do painel de detalhes. Sem ele o
    // "Buscando fluxos..." saia em `text-base` ao lado de uma caixa de busca
    // em `text-xs`, e o vazio que ocupa ESTE MESMO lugar
    // (`PanelEmptyState`) fala em `text-xs text-muted`: eram duas mensagens
    // no mesmo ponto da tela, dois tamanhos e duas cores de distancia.
    compact: { type: Boolean, default: false },
  },
};
</script>

<template>
  <div
    class="flex items-center justify-center"
    :class="compact ? 'p-4' : 'p-8'"
  >
    <p
      class="flex items-center gap-2"
      :class="
        compact ? 'm-0 text-xs text-muted' : 'text-base font-medium text-body'
      "
    >
      <span>{{ message }}</span>
      <span class="spinner" :class="{ 'spinner--compact': compact }" />
    </p>
  </div>
</template>

<style scoped>
/* O `.spinner` global mede 24px com um circulo de 16px dentro, desenhado num
   `::before` posicionado pelo centro. Encolher so a caixa deixaria o circulo
   do mesmo tamanho, entao as duas medidas e as duas margens negativas (que
   sao metade do circulo) andam juntas.

   Regra com escopo, e nao utilitarios no `class`: `.spinner` vem do SCSS
   global em (0,1,0), e uma utilitaria de Tailwind empata com ela -- quem
   ganharia seria a ordem do bundle. Com o `[data-v-…]` do escopo a disputa
   acaba em (0,2,0). */
.spinner--compact {
  width: 1rem;
  height: 1rem;
  padding: 0 1rem;
}

.spinner--compact::before {
  width: 0.75rem;
  height: 0.75rem;
  margin-top: -0.375rem;
  margin-left: -0.375rem;
}
</style>
